<template>
  <Sheet class="p-4" height="70%">
    <div v-if="products.length > 0">
      <CartFoodCard v-for="product in products"
                    :key="product.id"
                    :product="product"/>

      <div class="text-sm flex justify-between bg-gray-900 rounded-lg p-4 mt-4 text-white">
        <span>جمع کل:</span>
        <span class="text-green-500">{{ $helper.priceFormatter(cartPrice) }}</span>
      </div>

      <form action="" @submit.prevent="submitOrder()">
        <div class="flex mt-4">

          <VInput class="w-full mr-2" type="number" placeholder="شماره اتاق" disabled="disabled" :value="room_number"
                  :error="roomError" required/>
          <VButton class="px-1 mr-1" @click="cart = false">
            <router-link :to="{path: '/qr', query: {callback: 'cart' }}">
              <QrcodeIcon class="w-6 h-6"/>
            </router-link>
          </VButton>
        </div>
        <span class="text-xs text-red-500 mt-2 mr-2" v-if="roomError">{{ roomError }}</span>

        <VButton class="w-full mt-4" type="submit">ثبت</VButton>
      </form>
    </div>

    <div class="mt-16" v-else>
      <h1 class="text-gray-500 text-lg text-center">{{ $t('empty_cart_message')}}</h1>
      <VButton class="w-full mt-4">
        <router-link to="/menu" @click="cart = false">{{ $t('cart_start_order_button')}}</router-link>
      </VButton>
    </div>
  </Sheet>
</template>

<script>
import VButton from "@/components/General/VButton";
import CartFoodCard from "@/components/CartProductCard";
import {Sheet} from "bottom-sheet-vue3";
import VInput from "@/components/General/VInput";
import {QrcodeIcon} from "@heroicons/vue/outline";
import {mapGetters, mapState} from "vuex";
import {postOrderProducts} from "@/API/API";

export default {
  name: "CartBottomSheet",
  components: {
    VInput,
    VButton,
    CartFoodCard,
    Sheet,
    QrcodeIcon,
  },
  data() {
    return {
      // Bind Local Cart data to Global $cart var
      cart: this.$cart,
      roomError: ''
    }
  },
  computed: {
    ...mapState({
      products: state => state.cart.cart,
      room_number: state => state.roomNumber
    }),
    ...mapGetters(['cartPrice']),
  },
  methods: {
    async submitOrder() {
      if (!this.room_number) {
        this.roomError = "لطفا QR کد اتاق خود را اسکن کنید"
        return
      }
      let order = {
        room_number: this.room_number ?? '',
        products: this.products,
      }
      postOrderProducts(order)
          .then((resp) => {
            this.$store.dispatch('emptyCart')
            this.$cart.value = false
            this.$swal({
              icon: 'success',
              title: 'موفق',
              text: 'سفارش با موفقیت ثبت شد. برای پرداخت روی دکمه زیر کلیک کنید.',
              confirmButtonColor: '#fcd34d',
              confirmButtonText: 'پرداخت'
            }).then(() => {
              window.location.href = resp.data.action;
            })
          })
          .catch(err => {
            this.$store.dispatch('changeCart', err.response.data.products)
          })
    }
  },
}
</script>

<style scoped>

</style>